import useTranslation from "next-translate/useTranslation"
import { useState } from "react"
import { Button } from "reactstrap"

import Icon from "@components/common/Icon"
import { useTooltip } from "@services/tooltipHook"

interface IProps {
  url: string
  id: string
}

/**
 * This component provides a "share the link" button.
 * It is used in the public project profile.
 */
const ShareButton: React.FC<IProps> = ({ url }: IProps) => {
  const { t } = useTranslation("common")

  const clickToCopyText = t("page.projects.slug.copyUrl")
  const [tooltipText, setTooltipText] = useState(clickToCopyText)

  const { tooltipTargetRef, ToolTip } = useTooltip(tooltipText)

  const copyUrlToClipboard = () => {
    void navigator.clipboard.writeText(url)
    setTooltipText(t("page.projects.slug.urlCopied"))
    setTimeout(() => setTooltipText(clickToCopyText), 5000)
  }

  // using button instead of reactstrap Button to be able to bind the tooltip-ref to the element
  return <>
    <Button
      className="round-icon-btn"
      onClick={copyUrlToClipboard}
      innerRef={tooltipTargetRef}
    >
      <Icon name="share" size={25} />
    </Button>
    {ToolTip}
  </>
}

export default ShareButton
